var Channel = require('channel');
var OrderedBufferList = require('orderedbufferlist');


var ChannelList = OrderedBufferList.extend({
    model: Channel
});


module.exports = ChannelList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/channellist.js
// module id = 61Uw
// module chunks = 1